export default __webpack_public_path__ + "static/media/video-4.1c64b1ef.mp4";